import { render, staticRenderFns } from "./WikiContentArticle.vue?vue&type=template&id=b3fd9044"
import script from "./WikiContentArticle.vue?vue&type=script&lang=js"
export * from "./WikiContentArticle.vue?vue&type=script&lang=js"
import style0 from "./WikiContentArticle.vue?vue&type=style&index=0&id=b3fd9044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports